import { leanModal } from "../plugins/leanModal";

/**
 * connects angular with jquery-leandModal
 *
 * @see http://leanmodal.finelysliced.com.au/
 *
 * modal=trigger is the trigger to show the modal (it sets also the href-attribute)
 * modal=target is the target or the modal for the trigger
 *
 * need also the attribute modal-id or data-modalId or similar things
 *
 * the modal moved to #wrapper whith this directive
 */
const ModalDirective = function () {

  return {
    restrict: 'A',
    scope: {
      modal: "@",
      modalid: "@"
    },
    link: function ($scope, $element, $attr) {
      var $jqElement = angular.element($element);
      if ($scope.modal === 'trigger' && $scope.modalid) {
        $jqElement.attr('href', '#' + $scope.modalid);
        $jqElement.extend({ leanModal });
        $jqElement.leanModal({ closeButton: '.close' });
      } else if ($attr.modal === 'target') {
        $jqElement.attr('id', $attr.modalid);
        $jqElement.appendTo('#wrapper');
      }
    }
  };
};

export default ModalDirective;
